import styled from 'styled-components'

export const ConversionPreview = styled.div`
  font-size: 0.75rem;
  color: ${props => props.theme.colors.text.muted};
  margin-top: 0.375rem;
  font-family: ${props => props.theme.typography.fontFamily};
  font-style: italic;
`
